import { useState } from 'react';

export function DivergingMeter({ yesValue, noValue }) {
  const [activeSegment, setActiveSegment] = useState(null);
  const total = yesValue + noValue || 1;
  const yesPercent = (yesValue / total) * 100;
  const noPercent = (noValue / total) * 100;

  const yesIsZero = yesValue === 0 || yesPercent === 0;
  const noIsZero = noValue === 0 || noPercent === 0;
  const bothNonZero = !yesIsZero && !noIsZero;

  return (
    <div className="w-full">
      <div className="relative flex items-stretch rounded-full h-12 group shadow-[inset_0_1px_2px_rgba(255,255,255,0.1),0_4px_12px_rgba(0,0,0,0.3)]">
        {bothNonZero ? (
          <>
            <button
              className={`diverging-meter__segment yes relative flex items-center justify-center font-semibold text-xs md:text-sm whitespace-nowrap px-2 cursor-pointer transition-all duration-300 border-y border-l border-emerald-600/40 rounded-l-full origin-right backdrop-blur-sm ${
                activeSegment === 'yes' ? 'scale-105 z-10 shadow-[0_4px_20px_rgba(16,185,129,0.6),inset_0_1px_1px_rgba(255,255,255,0.2)]' : 'shadow-[inset_0_1px_1px_rgba(255,255,255,0.1)]'
              }`}
              style={{ width: `${yesPercent}%` }}
              onMouseEnter={() => setActiveSegment('yes')}
              onMouseLeave={() => setActiveSegment(null)}
              onClick={() => setActiveSegment(activeSegment === 'yes' ? null : 'yes')}
            >
              {Math.round(yesPercent)}%
              {activeSegment === 'yes' && (
                <div className="absolute -top-10 left-1/2 -translate-x-1/2 px-3 py-1.5 bg-slate-800 border border-emerald-500/50 rounded-lg shadow-lg whitespace-nowrap animate-in fade-in slide-in-from-bottom-2 duration-200">
                  <div className="text-xs font-medium text-emerald-400">Yes</div>
                  <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 rotate-45 w-2 h-2 bg-slate-800 border-r border-b border-emerald-500/50"></div>
                </div>
              )}
            </button>
            <button
              className={`diverging-meter__segment no relative flex items-center justify-center font-semibold text-xs md:text-sm whitespace-nowrap px-2 cursor-pointer transition-all duration-300 border-y border-r border-red-600/40 rounded-r-full -ml-px origin-left backdrop-blur-sm ${
                activeSegment === 'no' ? 'scale-105 z-10 shadow-[0_4px_20px_rgba(239,68,68,0.6),inset_0_1px_1px_rgba(255,255,255,0.2)]' : 'shadow-[inset_0_1px_1px_rgba(255,255,255,0.1)]'
              }`}
              style={{ width: `${noPercent}%` }}
              onMouseEnter={() => setActiveSegment('no')}
              onMouseLeave={() => setActiveSegment(null)}
              onClick={() => setActiveSegment(activeSegment === 'no' ? null : 'no')}
            >
              {Math.round(noPercent)}%
              {activeSegment === 'no' && (
                <div className="absolute -top-10 left-1/2 -translate-x-1/2 px-3 py-1.5 bg-slate-800 border border-red-500/50 rounded-lg shadow-lg whitespace-nowrap animate-in fade-in slide-in-from-bottom-2 duration-200">
                  <div className="text-xs font-medium text-red-400">No</div>
                  <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 rotate-45 w-2 h-2 bg-slate-800 border-r border-b border-red-500/50"></div>
                </div>
              )}
            </button>
          </>
        ) : (
          <>
            {!yesIsZero && (
              <button
                className={`diverging-meter__segment yes relative flex items-center justify-center font-semibold text-xs md:text-sm whitespace-nowrap px-2 cursor-pointer transition-all duration-300 border border-emerald-600/40 rounded-full backdrop-blur-sm ${
                  activeSegment === 'yes' ? 'scale-105 z-10 shadow-[0_4px_20px_rgba(16,185,129,0.6),inset_0_1px_1px_rgba(255,255,255,0.2)]' : 'shadow-[inset_0_1px_1px_rgba(255,255,255,0.1)]'
                }`}
                style={{ width: '100%' }}
                onMouseEnter={() => setActiveSegment('yes')}
                onMouseLeave={() => setActiveSegment(null)}
                onClick={() => setActiveSegment(activeSegment === 'yes' ? null : 'yes')}
              >
                {Math.round(yesPercent)}%
                {activeSegment === 'yes' && (
                  <div className="absolute -top-10 left-1/2 -translate-x-1/2 px-3 py-1.5 bg-slate-800 border border-emerald-500/50 rounded-lg shadow-lg whitespace-nowrap animate-in fade-in slide-in-from-bottom-2 duration-200">
                    <div className="text-xs font-medium text-emerald-400">Yes</div>
                    <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 rotate-45 w-2 h-2 bg-slate-800 border-r border-b border-emerald-500/50"></div>
                  </div>
                )}
              </button>
            )}
            {!noIsZero && (
              <button
                className={`diverging-meter__segment no relative flex items-center justify-center font-semibold text-xs md:text-sm whitespace-nowrap px-2 cursor-pointer transition-all duration-300 border border-red-600/40 rounded-full backdrop-blur-sm ${
                  activeSegment === 'no' ? 'scale-105 z-10 shadow-[0_4px_20px_rgba(239,68,68,0.6),inset_0_1px_1px_rgba(255,255,255,0.2)]' : 'shadow-[inset_0_1px_1px_rgba(255,255,255,0.1)]'
                }`}
                style={{ width: '100%' }}
                onMouseEnter={() => setActiveSegment('no')}
                onMouseLeave={() => setActiveSegment(null)}
                onClick={() => setActiveSegment(activeSegment === 'no' ? null : 'no')}
              >
                {Math.round(noPercent)}%
                {activeSegment === 'no' && (
                  <div className="absolute -top-10 left-1/2 -translate-x-1/2 px-3 py-1.5 bg-slate-800 border border-red-500/50 rounded-lg shadow-lg whitespace-nowrap animate-in fade-in slide-in-from-bottom-2 duration-200">
                  <div className="text-xs font-medium text-red-400">No</div>
                  <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 rotate-45 w-2 h-2 bg-slate-800 border-r border-b border-red-500/50"></div>
                </div>
              )}
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
